import hayaSelectConfig from "haya-select/build/config"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"

hayaSelectConfig.setUseTranslate(() => {
  return useI18n({namespace: "haya_select"})
})
